document.addEventListener('DOMContentLoaded',()=>{
  const menu=document.querySelector('.cc-moments-menu');
  if(!menu) return;

  /* Coffee + Treat: JS only selects the intended transparent assets.
     Sizing and positioning are deliberately left to cc-moments-tuning.css. */
  const coffee=menu.querySelector('.cc-moment-card--coffee .cc-mood-card__art img');
  const treat=menu.querySelector('.cc-moment-card--treat .cc-mood-card__art img');
  const errand=menu.querySelector('.cc-moment-card--errand .cc-mood-card__art img');
  const because=menu.querySelector('.cc-moment-card--because .cc-mood-card__art img');

  if(coffee){
    coffee.src='https://cdn.shopify.com/s/files/1/0685/7401/9715/files/cc-moment-coffee-transparent-final.png?v=1787112593';
  }
  if(treat){
    treat.src='https://cdn.shopify.com/s/files/1/0685/7401/9715/files/cc-moment-treat-transparent-final.png?v=1787112601';
  }

  /* Keep the previously approved Errand / Just Because inline tuning untouched for now. */
  if(errand){
    errand.style.setProperty('width','76%','important');
    errand.style.setProperty('max-width','76%','important');
    errand.style.setProperty('max-height','98%','important');
    errand.style.setProperty('height','auto','important');
    errand.style.setProperty('object-fit','contain','important');
    errand.style.setProperty('margin','auto','important');
    errand.style.setProperty('transform','none','important');
  }
  if(because){
    because.style.setProperty('width','130%','important');
    because.style.setProperty('max-width','none','important');
    because.style.setProperty('max-height','none','important');
    because.style.setProperty('height','auto','important');
    because.style.setProperty('margin','0 auto','important');
    because.style.setProperty('transform','translateY(34px)','important');
  }

  const art=menu.querySelector('.cc-mood-menu__hero-art');
  if(art&&!art.querySelector('.cc-mood-menu__sticker')){
    ['sweet','sarcastic','unhinged'].forEach(kind=>{
      const s=document.createElement('span');
      s.className='cc-mood-menu__sticker cc-mood-menu__sticker--'+kind;
      s.setAttribute('aria-hidden','true');
      art.appendChild(s);
    });
  }
});
